import axios from "axios";

const API_URL = "/api/auth/";

export const register = async (username, email, password1, password2) => {
  const res = await axios.post(`${API_URL}registration/`, {
    username,
    email,
    password1,
    password2,
  });
  const token = res.data.key;
  localStorage.setItem("authToken", token);
  return token;
};

export const login = async (email, password) => {
  const res = await axios.post(`${API_URL}login/`, {
    email,
    password,
  });
  const token = res.data.key;
  localStorage.setItem("authToken", token);
  return token;
};

export const logout = async () => {
  const token = localStorage.getItem("authToken");
  await axios.post(`${API_URL}logout/`, null, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });
  localStorage.removeItem("authToken");
};

export const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

